import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor,
  HttpHandler, HttpResponse,
  HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable, BehaviorSubject, of, throwError } from 'rxjs';
import { catchError, filter, finalize, take, map } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators/switchMap';
import {ToastService} from '../toast.service';

@Injectable({
  providedIn: 'root'
})

export class XsrfInterceptor implements HttpInterceptor {

  private AUTH_HEADER = 'Authorization';
  private token = 'secrettoken';
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private tservice: ToastService){

  }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
     
      //console.log(`Request api --->>> ${req.url} has been intercepted!`);
      // return next.handle(req);
      const token: string = localStorage.getItem('authData');
      if (token) {
            const tokenString = JSON.parse(token);
            //console.log(tokenString.token);

          req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + tokenString.token) });
      }

      if (!req.headers.has('Content-Type') && !req.headers.has('enctype')) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
        }

      req = req.clone({ headers: req.headers.set('Accept', 'application/json') });


      //console.log('---------------------------TEST-');
      const loader = document.getElementById('loader-class');
      if(loader){
        const x = req.url.includes('suggest');
        if(!x){
            loader.style.display = 'block';
        }
      }

      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
            
            if (event instanceof HttpResponse) {
                
                if(loader){
                  //console.log('inside loader');
                loader.style.display = 'none';
              }
                //console.log('response event--->>>', event);
                // this.addToast({title:'Bootstrap Toasty', msg:'Turning standard Bootstrap alerts into awesome notifications', showClose: true, timeout: 5000, theme:'bootstrap', type:'wait', position:'top-left', closeOther:true});
                // if(event.body.msg) {
                //   this.tservice.addToast({
                //     title: 'Error',
                //     msg: event.body.msg,
                //     showClose: true,
                //     timeout: 5000, 
                //     theme: 'default', 
                //     type: 'success', 
                //     position: 'top-right', 
                //     closeOther:true
                //   });
      
                // }
            }
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
            if(loader){
                loader.style.display = 'none';
              }
          let data = {};
          data = {
              name: error.name,
              reason: error.message,
              status: error.status
          };
          // this.errorDialogService.openDialog(data);
          console.log('response error log--->>>', data);
          // this.tservice.addToast({
          //   title: 'Error',
          //   msg: error.message,
          //   showClose: true,
          //   timeout: 5000, 
          //   theme: 'default', 
          //   type: 'error', 
          //   position: 'top-right', 
          //   closeOther:true
          // });

          return throwError(error);
      })
      );

      // if (!req.headers.has('Content-Type')) {
      //   req = req.clone({
      //     headers: req.headers.set('Content-Type', 'application/json')
      //   });
      // }

      // req = this.addAuthenticationToken(req);


      // return next.handle(req).pipe(
      //   catchError((error: HttpErrorResponse) => {
      //     if (error && error.status === 401) {
      //       // 401 errors are most likely going to be because we have an expired token that we need to refresh.
      //       if (this.refreshTokenInProgress) {
      //         // If refreshTokenInProgress is true, we will wait until refreshTokenSubject has a non-null value
      //         // which means the new token is ready and we can retry the req again
      //         return this.refreshTokenSubject.pipe(
      //           filter(result => result !== null),
      //           take(1),
      //           switchMap(() => next.handle(this.addAuthenticationToken(req)))
      //         );
      //       } else {
      //         this.refreshTokenInProgress = true;

      //         // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
      //         this.refreshTokenSubject.next(null);

      //         return this.refreshAccessToken().pipe(
      //           switchMap((success: boolean) => {
      //             this.refreshTokenSubject.next(success);
      //             return next.handle(this.addAuthenticationToken(req));
      //           }),
      //           // When the call to refreshToken completes we reset the refreshTokenInProgress to false
      //           // for the next time the token needs to be refreshed
      //           finalize(() => this.refreshTokenInProgress = false)
      //         );
      //       }
      //     } else {
      //       return throwError(error);
      //     }
      //   })
      // );
    }

  private refreshAccessToken(): Observable<any> {
    return of('secret token');
  }

  private addAuthenticationToken(req: HttpRequest<any>): HttpRequest<any> {
    // If we do not have a token yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    if (!this.token) {
      return req;
    }
    // If you are calling an outside domain then do not add the token.
    if (!req.url.match(/www.mydomain.com\//)) {
      return req;
    }
    return req.clone({
      headers: req.headers.set(this.AUTH_HEADER, 'Bearer ' + this.token)
    });
  }

}
